import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    let model = super.payloadKeyFromModelName(modelName).replace(/^cron\//, '');
    return model;
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('cron/' + key);
  }
}
